export default __webpack_public_path__ + "static/media/login_bg.715f6cd1.jpg";